module.exports = __webpack_public_path__ + "img/HLK3.png";